import {MachineSpecification} from '~/types';
import store from "~/store";
import { isLastUsedMachine } from '~/sqlite/lastUsedCache';
import QueryBuilder from "./queryBuilder";
import { DatabaseClient, getDatabaseClient } from '~/data/db/DatabaseClient';
import { resolveOfflineDb } from './offlineDatabase';

export class MachineSpecificationOfflineService {

    constructor(private readonly databaseClient: DatabaseClient | null = getDatabaseClient()) {}

    private readonly qb: QueryBuilder = new QueryBuilder();
    private get SQLite() {
        return resolveOfflineDb(this.databaseClient);
    }

    public reset(machines: MachineSpecification[]): Promise<void | undefined> {
        const db = this.SQLite;
        if (!db || !machines.length) return Promise.resolve();

        return new Promise<void>((resolve, reject) => {
            db.transaction((tx) => {
                const { query: truncateQuery, params: truncateParams } = this.qb.truncate('MachineSpecification');
                tx.executeSql(truncateQuery, truncateParams);
                const { query: insertQuery, params: insertParams } = this.qb.insert('MachineSpecification', machines.map((machine) => {
                    return {
                        ...machine,
                        data: JSON.stringify(machine)
                    }
                }));
                tx.executeSql(insertQuery, insertParams);
            }, (e) => reject(e), resolve);
        });
    }

    public getMachineEquipments(id: string): Promise<MachineSpecification[]> {
        const db = this.SQLite;
        if (!db) return Promise.resolve([]);

        const where = [{name: 'id', value: id}];
        const { query: machineQuery, params: machineParams } = this.qb.select('Machine', [], where);

        return new Promise<MachineSpecification[]>((resolve, reject) => {
            db.executeSql(machineQuery, machineParams, (result) => {
                const excavatorData = this.qb.getSingleResult(result);
                if (excavatorData?.data) {
                    const { query, params } = this.qb.select('MachineSpecification', [], [{
                        name: 'hovedNo',
                        value: JSON.parse(excavatorData.data)?.intern
                    }]);
                    db.executeSql(query, params, (resultSet) => resolve(this.qb.getAllResult(resultSet).map((result) => JSON.parse(result.data))), (e) => reject(e));
                } else {
                    resolve([]);
                }
            }, (e) => reject(e));
        });
    }

    public getMachineSpecifications(id: string): Promise<MachineSpecification | undefined> {
        const db = this.SQLite;
        if (!db) return Promise.resolve(undefined);

        const where = [{name: 'id', value: id}];
        let machineSpecification: MachineSpecification | undefined;
        return new Promise<MachineSpecification | undefined>((resolve, reject) => {
            db.transaction((SQLite) => {
                const { query, params } = this.qb.select('MachineSpecification', [], where);
                SQLite.executeSql(query, params, (_SQLite, result) => {
                    const machineSpecificationRow = this.qb.getSingleResult(result);
                    if(machineSpecificationRow?.data) {
                        machineSpecification = JSON.parse(machineSpecificationRow.data);
                    }
                });
            }, (e) => reject(e), () => resolve(machineSpecification));
        });
    }

    public updateMachineSpecifications(machine: MachineSpecification) {
        if (this.SQLite && (store.getState().machines.inFavorite(store.getState().machine.data.id) || isLastUsedMachine(store.getState().machine.data.id))) {
            const qb = new QueryBuilder();
            this.SQLite.transaction((tx) => {
                const { query, params } = qb.update('MachineSpecification',
                    {
                        id: machine.id,
                        hovedNo: machine.hovedNo,
                        data: JSON.stringify({...machine})
                    },
                    [
                        {name: 'id', value: machine.id}
                    ]
                );
                tx.executeSql(query, params);
            });
        }
    }
}
